import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "syllabus",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "syllabus-insights" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [],
});
